export const UPDATE_POPUP = 'UPDATE_POPUP' as const;
export const RESET_POPUP = 'RESET_POPUP' as const;
